export default "__VITE_ASSET__e1f55c04__"